import React from 'react';
import { Loader2Icon } from 'lucide-react';
interface NeuroToastProps {
  message: string | null;
}
export const NeuroToast = ({
  message
}: NeuroToastProps) => <div role="status" aria-live="polite" className={`fixed bottom-20 right-6 z-50 transition-[opacity,transform] duration-200 ease-out ${message ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'}`} data-id="element-587" data-mp="3uqa6iyuws25">
    {message && <div className="flex items-center gap-2 rounded-lg bg-[#111827] px-4 py-3 text-sm text-white shadow-lg" data-id="element-588" data-mp="3l56fqjejo39a">
        <Loader2Icon className="w-4 h-4 animate-spin" strokeWidth={1.75} aria-hidden="true" data-id="element-589" data-mp="3h4w3ip05sglz" />
        {message}
      </div>}
  </div>;
export default NeuroToast;